import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { MatInputModule } from '@angular/material/input'
import { MatDialogModule } from '@angular/material/dialog'

@Component({
  selector: 'app-confirm-add-part-dialog',
  templateUrl: './confirm-add-part-dialog.component.component.html',
  styleUrl: './confirm-add-part-dialog.component.component.css',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    CommonModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
  ],
})
export class ConfirmAddPartDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmAddPartDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { input: string; description?: string },
  ) {}

  confirm(): void {
    this.dialogRef.close({
      proceed: true,
      description: this.data.description || '',
    })
  }
}
